import { ButtonColorType } from 'antd/es/button';
import { FC } from 'react';

import styles from './AssignedIssueItem.module.scss';

export interface AssignedIssueItemProps {
  label: string;
  color: ButtonColorType;
  rightSection?: React.ReactNode;
  onLabelClick?: () => void;
}

const AssignedIssueItem: FC<AssignedIssueItemProps> = ({ label, color, rightSection, onLabelClick }) => {
  return (
    <div className={`${styles.container} ${styles[color]}`}>
      <div className={styles.content}>
        <div className={`${styles.label} ${onLabelClick ? styles.clickable : ''}`} onClick={onLabelClick}>
          {label}
        </div>
        {rightSection && <div className={styles.rightSection}>{rightSection}</div>}
      </div>
    </div>
  );
};

export default AssignedIssueItem;
